import React, { Component } from 'react';
import { connect } from 'react-redux';
import SelectGroup from 'components/vendor-requests/shared/SelectGroup';
import styled from 'styled-components';
import { BorderWrapper, FlexRow, Title } from 'components/styled-components';
import { InputGroup, TextArea, Icon } from '@blueprintjs/core';
import { DateInput } from '@blueprintjs/datetime';
import colors from 'utils/colors';
import filter from 'lodash/filter';
import includes from 'lodash/includes';
import { iconPicker, If } from 'utils/functions';
import { fetchAllRequestStatus, fetchAllDepartments } from 'actions/utils';
import moment from 'moment';
import join from 'lodash/join';
import hasPermission from 'utils/hasPermission';
import Permissions from 'utils/permissions';
import { ErrorMessage } from 'formik';
import ErrorWrapper from 'components/forms/components/error-wrapper';
import { getMaxDate } from 'utils/functions';

const getDateFormatter = () => {
  const format = 'MM/DD/YYYY';
  const locale = 'en';
  return {
    formatDate: date =>
      moment(date)
        .locale(locale)
        .format(format),
    parseDate: str =>
      moment(str, format)
        .locale(locale)
        .toDate(),
    placeholder: format,
  };
};

const mapDepartments = (selected, departments) => {
  if (selected) {
    if (typeof selected[0] === 'string') {
      return filter(departments, department =>
        includes(selected, department.departmentName)
      );
    } else {
      return selected;
    }
  }
};

const mapStatuses = (selected, statuses) => {
  if (selected) {
    if (typeof selected[0] === 'string') {
      return filter(statuses, status => includes(selected, status.statusName));
    } else {
      return selected;
    }
  }
};

const removeATPCStatus = statuses => {
  return statuses.filter(
    status => status.statusName !== 'Awaiting Third Party Completion'
  );
};

class RequestInfo extends Component {
  state = {
    showInput: false,
  };

  componentDidMount() {
    this.props.fetchAllRequestStatus();
    this.props.fetchAllDepartments();
    this.checkStatus();
  }

  componentDidUpdate(prevProps) {
    const { requestStatus } = this.props.values;
    if (prevProps.values.requestStatus !== requestStatus) {
      this.checkStatus();
    }
  }

  checkStatus = () => {
    const { requestStatus } = this.props.values;
    const status =
      typeof requestStatus === 'object'
        ? requestStatus.statusName
        : requestStatus;
    if (
      status === 'Manual Approval' ||
      status === 'Manual Denied' ||
      status === 'Conditional Approval'
    ) {
      this.setState({ showInput: true });
    } else {
      this.setState({ showInput: false });
    }
  };

  render() {
    const { showInput } = this.state;
    const { editing, appUser, request, values } = this.props;
    const icon = iconPicker(request.statusCategory);
    let minRenewaldate = new Date();
    let minRenewaldateAfter = new Date();
    minRenewaldate.setDate(minRenewaldate.getDate() + 17);
    minRenewaldateAfter.setDate(minRenewaldateAfter.getDate() + 16);
    return (
      <BorderWrapper margin="1rem">
        <DataWrapper>
          <Heading>
            <Title>Assessment Information</Title>
          </Heading>
          <FlexRow>
            <div>
              <MutedLabel>Assessment ID:</MutedLabel>
              <div>{request.vendorRequestID}</div>
            </div>

            {hasPermission(
              appUser.permissions,
              Permissions.VIEW_DEPARTMENTS
            ) && (
              <div style={{ width: '40%' }}>
                <MutedLabel>Requesting Departments</MutedLabel>
                <If condition={editing}>
                  <SelectGroup
                    isMulti={true}
                    value={mapDepartments(
                      values.departmentsRequesting,
                      this.props.departments
                    )}
                    getOptionLabel={option => option.departmentName}
                    getOptionValue={option => option.departmentID}
                    options={this.props.departments}
                    changeHandler={this.props.setFieldValue}
                    name="departmentsRequesting"
                  />
                </If>
                <If condition={!editing}>
                  <div>{join(request.departmentsRequesting, ', ')}</div>
                </If>
              </div>
            )}
          </FlexRow>
          <FlexRow>
            <div>
              <MutedLabel>Req/PO/Invoice</MutedLabel>
              <If condition={editing}>
                <InputGroup
                  fill={true}
                  value={values.reqPoInvoice}
                  disabled={!editing}
                  onChange={this.props.handleChange}
                  name="reqPoInvoice"
                />
              </If>
              <If condition={!editing}>
                <div>{request.reqPoInvoice ? request.reqPoInvoice : 'N/A'}</div>
              </If>
            </div>
            <div style={{ width: '40%', overflowWrap: 'break-word' }}>
              <MutedLabel>Description</MutedLabel>
              <If condition={editing}>
                <TextArea
                  fill={true}
                  value={values.description}
                  disabled={!editing}
                  onChange={this.props.handleChange}
                  name="description"
                  maxLength={500}
                  minLength={1}
                />
              </If>
              <If condition={!editing}>
                <div>{request.description ? request.description : 'N/A'}</div>
              </If>
            </div>
          </FlexRow>

          {hasPermission(appUser.permissions, [
            Permissions.MODIFY_ALL_THIRD_PARTY_REQUESTS,
            Permissions.MODIFY_OWNED_THIRD_PARTY_REQUESTS,
          ]) && (
            <div>
              <MutedLabel>Assessment Status</MutedLabel>
              {editing && (
                <>
                  {hasPermission(appUser.permissions, [
                    Permissions.MODIFY_ALL_REQUESTS_STATUSES,
                  ]) ? (
                    <SelectGroup
                      value={mapStatuses(
                        values.requestStatus,
                        this.props.requestStatuses
                      )}
                      options={removeATPCStatus(this.props.requestStatuses)}
                      getOptionLabel={option => option.statusName}
                      getOptionValue={option => option.vendorRequestStatusID}
                      changeHandler={this.props.setFieldValue}
                      name="requestStatus"
                    />
                  ) : (
                    <div>
                      {icon && (
                        <Icon
                          icon={icon.icon}
                          intent={icon.intent}
                          style={{ marginRight: 10 }}
                        />
                      )}
                      {request.requestStatus}
                    </div>
                  )}
                </>
              )}
              <If condition={!editing}>
                <div>
                  {icon && (
                    <Icon
                      icon={icon.icon}
                      intent={icon.intent}
                      style={{ marginRight: 10 }}
                    />
                  )}
                  {request.requestStatus}
                </div>
              </If>
            </div>
          )}

          {hasPermission(appUser.permissions, [
            Permissions.MODIFY_ALL_THIRD_PARTY_REQUESTS,
            Permissions.MODIFY_OWNED_THIRD_PARTY_REQUESTS,
          ]) && (
            <div>
              <MutedLabel>Override Note</MutedLabel>
              {editing && showInput ? (
                <>
                  <InputGroup
                    value={values.overrideNote || ''}
                    disabled={!editing}
                    onChange={this.props.handleChange}
                    name="overrideNote"
                  />
                  <ErrorMessage
                    name="overrideNote"
                    render={msg => <ErrorWrapper>{msg}</ErrorWrapper>}
                  />
                </>
              ) : (
                <div>{request.overrideNote ? request.overrideNote : 'N/A'}</div>
              )}
            </div>
          )}
          <div>
            <MutedLabel>Reason for Dispute</MutedLabel>
            <div>{request.rejectionNote ? request.rejectionNote : 'N/A'}</div>
          </div>
          <FlexRow>
            <div>
              <MutedLabel>Assessment Created Date</MutedLabel>
              <If condition={editing}>
                <DateInput
                  {...getDateFormatter()}
                  disabled={true}
                  value={new Date(request.requestSubmittedDate)}
                />
              </If>
              <If condition={!editing}>
                <Icon
                  icon="calendar"
                  color={colors.muted}
                  style={{ marginRight: 10 }}
                />
                {moment(request.requestSubmittedDate).format('MM/DD/YYYY')}
              </If>
            </div>
            {hasPermission(appUser.permissions, [
              Permissions.VIEW_REQUEST_APPROVAL,
            ]) && (
            <div>
              <div>
                <MutedLabel>Approval Date</MutedLabel>
                <If condition={editing}>
                  <DateInput
                    {...getDateFormatter()}
                    value={
                      moment(values.approvalDate).isValid()
                        ? new Date(values.approvalDate)
                        : null
                    }
                    onChange={value =>
                      this.props.setFieldValue('approvalDate', value)
                    }
                    name="approvalDate"
                    disabled
                  />
                </If>
                <If condition={!editing}>
                  <Icon
                    icon="calendar"
                    color={colors.muted}
                    style={{ marginRight: 10 }}
                  />
                  {moment(request.approvalDate).isValid()
                    ? moment(request.approvalDate).format('MM/DD/YYYY')
                    : 'N/A'}
                </If>
              </div>
          
              <div>
                <MutedLabel>Renewal Date</MutedLabel>
                <If condition={editing}>
                  <DateInput
                    {...getDateFormatter()}
                    value={
                      moment(values.renewalDate).isValid() &&
                      moment(values.renewalDate).isAfter(minRenewaldateAfter)
                        ? new Date(values.renewalDate)
                        : null
                    }
                    onChange={value =>
                      this.props.setFieldValue('renewalDate', value)
                    }
                    name="renewalDate"
                    maxDate={getMaxDate()}
                    minDate={minRenewaldate}
                  />
                </If>
                <If condition={!editing}>
                  <Icon
                    icon="calendar"
                    color={colors.muted}
                    style={{ marginRight: 10 }}
                  />
                  {moment(request.renewalDate).isValid()
                    ? moment(request.renewalDate).format('MM/DD/YYYY')
                    : 'N/A'}
                </If>
              </div>
            </div>
             )}
          </FlexRow>
        </DataWrapper>
      </BorderWrapper>
    );
  }
}

const DataWrapper = styled.div`
  padding: 1rem;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  min-height: 350px;
`;

const Heading = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const MutedLabel = styled.span`
  color: ${colors.muted};
  font-size: 0.8rem;
  margin: 1rem 0 0.5rem;
  display: block;
`;

const mapStateToProps = state => ({
  requestStatuses: state.utils.requestStatus,
  departments: state.utils.departments,
});

RequestInfo = connect(
  mapStateToProps,
  { fetchAllRequestStatus, fetchAllDepartments }
)(RequestInfo);

export default RequestInfo;
